import { render, staticRenderFns } from "./EditLinkIcon.vue?vue&type=template&id=19ee1bcc&scoped=true&"
import script from "./EditLinkIcon.vue?vue&type=script&lang=ts&"
export * from "./EditLinkIcon.vue?vue&type=script&lang=ts&"
import style0 from "./EditLinkIcon.vue?vue&type=style&index=0&id=19ee1bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ee1bcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
